import * as React from 'react';

function SvgAnalytics(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M20.332 7a1.667 1.667 0 00-1.55 2.275l-3.508 3.507a1.66 1.66 0 00-1.216 0l-2.507-2.507a1.667 1.667 0 10-3.102 0l-4.174 4.173a1.667 1.667 0 10.943.943l4.173-4.173c.391.153.826.153 1.217 0l2.507 2.507a1.667 1.667 0 103.102 0l3.507-3.507a1.668 1.668 0 002.247-1.242A1.667 1.667 0 0020.332 7z" })));
}

export default SvgAnalytics;
